













import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";

import {
    VueFlux,
    FluxCaption,
    FluxPagination,
    Transitions
} from 'vue-flux';
import "swiper/dist/css/swiper.css";
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";
const swiperAni = require('@/assets/js/swiper.animate.min.js');
@Component({
    name: "HomeHeader",
    components: {
        VueFlux,
        FluxCaption,
        FluxPagination,
    }
})
export default class HomeHeader extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;

    fluxOptions: any = {
        autoplay: true,
        // delay: 4000
        fullscreen: true,
    };
    fluxTransitions: any = {
        transitionSlide: Transitions.transitionBlocks2
    };
    get deviceType() : string {
        const width = document.body.offsetWidth
        if (width <= 425) {
            return "mobile"
        } else if (width <= 1024){
            return "tab"
        } else {
            return "original"
        }
    }

    get slideImages() : string[] {
        if (this.compData != null){
            return this.compData.slides.map((slide: any, idx: number) => {
                return `${HOST}${slide.slider_image[this.deviceType].src}`
            })
        } else {
            return []
        }
    }

    get captions() : string[] {
        if (this.compData != null){
            return this.compData.slides.map((slide: any, idx: number) => {
                return slide.title
            })
        } else {
            return []
        }
    }
   
}
